module.exports = __webpack_public_path__ + "static/media/assist_1.63f82ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/img/assist_1.png
// module id = 111
// module chunks = 0